import clsx from 'clsx';
import { Link } from 'react-router-dom';
import styles from './styles.module.scss';

interface ActionButtonProps {
  className?: string;
  type?: string;
  content: string;
  action?: (e) => void;
  disable?: boolean;
  href?: string;
  'data-testid'?: string;
}

export function ActionButton({
  className,
  type,
  content,
  action,
  disable,
  href,
  'data-testid': dataTestId,
}: ActionButtonProps) {
  if (href) {
    return (
      <Link
        to={href}
        data-testid={dataTestId}
        className={clsx(
          className,
          type === 'dark' ? styles.darkRoot : styles.lightRoot,
          disable ? styles.disable : styles.noDisable
        )}
        onClick={disable ? () => {} : action}
      >
        <p className={type === 'dark' ? styles.lightDes : styles.darkDes}>{content}</p>
      </Link>
    );
  }
  return (
    <div
      data-testid={dataTestId}
      className={clsx(
        className,
        type === 'dark' ? styles.darkRoot : styles.lightRoot,
        disable ? styles.disable : styles.noDisable
      )}
      onClick={disable ? () => {} : action}
    >
      <p className={type === 'dark' ? styles.lightDes : styles.darkDes}>{content}</p>
    </div>
  );
}
